/* import __COLOCATED_TEMPLATE__ from './workflow-overview.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import templateOnlyComponent from '@ember/component/template-only';

export interface Args {
  workflowId: string | number;
  route: string;
  isFinEnabled?: boolean;
  isLoading?: boolean;
  isRequired?: boolean;
  isComplete?: boolean;
  isIntercomMessengerChannel?: boolean;
}

const WorkflowOverview = templateOnlyComponent<Args>();

export default WorkflowOverview;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::WorkflowOverview': typeof WorkflowOverview;
    'standalone/deploy/workflow-overview': typeof WorkflowOverview;
  }
}
